import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';

export const requireBatteriesPageAccess: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isInAdminOrgSync
    ? true
    : router.createUrlTree(['/projects']);
};
